// eslint-disable-next-line import/extensions
import IonMessage from './src/main.js';

export default IonMessage;
